import IframeBox from '@/components/iframe_box_ml/IframeBox';

const dgm = () => {
  return <IframeBox src="/systemManage/roleManage"></IframeBox>;
};

export default dgm;
